import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Stripe Checkout/Portal return to /myprofile/subscription. Send the customer back into
// the normal Dashboard (Profile → Subscription, or the AI pop-up that launched Checkout),
// keeping ?billing=... so the existing Subscription section shows the return/cancel state.
export function subscriptionReturnState(search = '') {
  let origin = null;
  if (new URLSearchParams(search).has('billing')) try { origin = JSON.parse(sessionStorage.getItem('subscription-return-origin') || 'null'); } catch (_) { origin = null; }
  sessionStorage.removeItem('subscription-return-origin');
  if (origin?.section === 'ai') return { section: 'ai', subscriptionReturn: { tool: typeof origin.tool === 'string' ? origin.tool : undefined } };
  return { section: 'profile', profileSection: 'subscription' };
}

export default function SubscriptionReturn() {
  const { search } = useLocation();
  const [state] = React.useState(() => subscriptionReturnState(search));
  return <Navigate to={`/home${search}`} replace state={state} />;
}
